import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/providers';
import { UserService } from '@/services';
import type { CurrentUser } from '@/types';

export function useMyAnnouncements(enabled = true) {
  const { isLoggedIn } = useAuth();

  return useQuery({
    queryKey: ['myAnnouncements'],
    queryFn: UserService.getMyAnnouncements,
    enabled: isLoggedIn && enabled,
    staleTime: 5 * 60 * 1000, // 5min cache
    retry: false,
  });
}

export function useAnnouncements(enabled = true) {
  return useQuery({
    queryKey: ['announcements'],
    queryFn: UserService.getAnnouncements,
    enabled,
    staleTime: 5 * 60 * 1000, // 5min cache
  });
}

export function useMarkAnnouncementsAsViewed() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: UserService.markAnnouncementsAsViewed,
    onSuccess: (updatedUser) => {
      // Update the current user with the new announcementsViewedAt
      queryClient.setQueryData<CurrentUser>(['currentUser'], updatedUser);
      // Invalidate announcements to refetch and get empty list
      queryClient.invalidateQueries({ queryKey: ['myAnnouncements'] });
    },
  });
}
